import { LinearProgress } from '@material-ui/core'
import { Form, Formik } from 'formik'
import { useEffect, useState } from 'react'
import { Paper } from 'src/components'
import { useContrato } from 'src/modules/contratos/hooks/useContrato'
import { apiSauceInstance } from 'src/services/api'
import snackbarStore from 'src/stores/snackbar'
import { SimularFreteContrato, SimularFreteContratoSave } from '../types'
import { schema } from '../validation'
import { DadosContrato } from './DadosContrato'
import { DadosSimulacao } from './DadosSimulacao'
import { ValoresSimulacao } from './ValoresSimulacao'

const initialValues = {
  contratoId: '',
  tabelaId: '',
  codigo: '',
  descricaoContrato: '',
  grupoNegociador: '',
  agrupadorProduto: '',
  tipoNegociacao: '',
  tipoPedagio: '',
  frete: '',
  adicionalEntrega: '',
  franquiaEntrega: '',

  centroCustoId: '',
  dataSimulacao: new Date(),
  capacidadeVeiculo: '',
  distancia: '',
  qtdEixos: '',
  qtdVolumes: '',
  qtdEntregas: '',
  aliquotaIcms: '',
  pedagio: ''
}

export const SimularFreteContratoForm = () => {
  const [loading, setLoading] = useState<boolean>(false)
  const [, contratoActions] = useContrato()
  const [simulacaoResult, setSimulacaoResult] = useState<SimularFreteContrato>()

  async function simular(data: SimularFreteContratoSave) {
    const response = await apiSauceInstance.post<
      SimularFreteContrato,
      { message: string }
    >('/simular-frete-contrato', data)

    if (response.ok) {
      setSimulacaoResult(response.data)
    } else {
      snackbarStore.setMessage(
        response.data?.message ?? 'Ocorreu um erro ao calcular a simulação'
      )
    }

    setLoading(false)
  }

  const handleReset = () => {
    setSimulacaoResult(undefined)
  }

  useEffect(() => {
    return () => {
      contratoActions.reset()
      setSimulacaoResult(undefined)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleSubmit = async (data: any) => {
    setLoading(true)
    simular({
      tabelaId: data.tabelaId.value,
      contratoId: data.contratoId.value,
      dataSimulacao: data.dataSimulacao,
      capacidadeVeiculo: data.capacidadeVeiculo.value,
      aliquotaIcms: data.aliquotaIcms / 100,
      pedagio: data.pedagio || undefined,
      qtdEixos: data.qtdEixos || undefined,
      qtdEntregas: data.qtdEntregas || undefined,
      qtdVolumes: data.qtdVolumes || 0,
      distancia: data.distancia,
      centroCustoId: data.centroCustoId.value
    } as SimularFreteContratoSave)
  }

  return (
    <Paper>
      <Formik
        initialValues={initialValues}
        validationSchema={schema}
        enableReinitialize
        onSubmit={handleSubmit}
        onReset={handleReset}
      >
        {() => (
          <Form>
            <DadosContrato handleReset={handleReset} />
            <DadosSimulacao loading={loading} />
          </Form>
        )}
      </Formik>
      {loading && <LinearProgress />}
      {!!simulacaoResult && (
        <ValoresSimulacao simulacaoResult={simulacaoResult} />
      )}
    </Paper>
  )
}
